const TYPES = require('reducers/constructorRecommendations').ACTION_TYPES;

function updateConstructorRecommendations(recommendations) {
    return {
        type: TYPES.UPDATE_RECOMMENDATIONS,
        payload: recommendations
    };
}

function updateRequestParams(params) {
    return {
        type: TYPES.UPDATE_REQUEST_PARAMS,
        payload: params
    };
}

module.exports = {
    TYPES,
    updateConstructorRecommendations,
    updateRequestParams
};
